// extracted by mini-css-extract-plugin
export default {"blue":"EmptyResult_blue__ZMEFl","paragraph":"EmptyResult_paragraph__pvXyq","list":"EmptyResult_list__1lcFy"};